// Utilitaires du module planning (saisons, calendrier, dispos).
// Toutes les dates sont manipulees en chaines 'AAAA-MM-JJ' construites a la main :
// ne jamais passer par toISOString() (bug UTC de fin de mois).

export const JOURS_COURTS = ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di']

export const STATUTS_SAISON = {
  collecte: 'Collecte des disponibilités',
  construction: 'Construction du planning',
  publie: 'Planning publié',
  archive: 'Archivée',
}

const MOIS_NOMS = ['', 'janvier', 'février', 'mars', 'avril', 'mai', 'juin',
  'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre']

export function nomMois(mois) {
  return MOIS_NOMS[mois]
}

export function iso(annee, mois, jour) {
  return `${annee}-${String(mois).padStart(2, '0')}-${String(jour).padStart(2, '0')}`
}

export function aujourdhui() {
  const n = new Date()
  return iso(n.getFullYear(), n.getMonth() + 1, n.getDate())
}

export function parseIso(s) {
  const [annee, mois, jour] = s.split('-').map(Number)
  return { annee, mois, jour }
}

// 0 = lundi ... 6 = dimanche
export function jourSemaine(s) {
  const { annee, mois, jour } = parseIso(s)
  return (new Date(annee, mois - 1, jour).getDay() + 6) % 7
}

export function nbJoursDuMois(annee, mois) {
  return new Date(annee, mois, 0).getDate()
}

// Liste des mois couverts par une saison : [{ annee, mois }, ...]
export function moisDeSaison(saison) {
  const d = parseIso(saison.date_debut)
  const f = parseIso(saison.date_fin)
  const res = []
  let a = d.annee
  let m = d.mois
  while (a < f.annee || (a === f.annee && m <= f.mois)) {
    res.push({ annee: a, mois: m })
    m += 1
    if (m === 13) { m = 1; a += 1 }
  }
  return res
}

export function formatCourt(s) {
  const { mois, jour } = parseIso(s)
  return `${JOURS_COURTS[jourSemaine(s)]} ${String(jour).padStart(2, '0')}/${String(mois).padStart(2, '0')}`
}

export function formatLong(s) {
  const { annee, mois, jour } = parseIso(s)
  return `${JOURS_COURTS[jourSemaine(s)]} ${jour} ${MOIS_NOMS[mois]} ${annee}`
}

// La collecte est-elle ouverte aux superviseurs ? (meme logique que la regle SQL dispos_ouvertes)
export function collecteOuverte(saison, today = aujourdhui()) {
  if (!saison || saison.statut !== 'collecte') return false
  if (saison.dispos_ouverture && today < saison.dispos_ouverture) return false
  if (saison.dispos_cloture && today > saison.dispos_cloture) return false
  return true
}

// Jour sans accueil ni supervision : rien a saisir pour un superviseur
export function jourFerme(jour) {
  return !jour || (!jour.accueil_ouvert && !jour.supervision_ouverte)
}

// Lecture paginee : PostgREST renvoie au plus 1000 lignes par requete.
// buildQuery doit renvoyer une requete ORDONNEE (ordre stable entre les pages).
export async function fetchAll(buildQuery, taillePage = 1000) {
  let debut = 0
  let tout = []
  for (;;) {
    const { data, error } = await buildQuery().range(debut, debut + taillePage - 1)
    if (error) return { data: tout, error }
    tout = tout.concat(data || [])
    if (!data || data.length < taillePage) break
    debut += taillePage
  }
  return { data: tout, error: null }
}
